module.exports = __webpack_public_path__ + "static/media/eyeIcon2.8c16d5d3.svg";